/**
 * FlyToCart custom element for animating product images to cart
 * This component creates a visual effect of a product "flying" to the cart when added
 */
class FlyToCart {
  /**
   * Animates an element flying from source to destination
   * @param {HTMLElement} source - The element to fly (usually product image)
   * @param {HTMLElement} destination - The target element (cart icon)
   */
  static fly(source, destination) {
    if (!source || !destination) return;

    // Create clone
    const clone = source.cloneNode(true);
    const sourceRect = source.getBoundingClientRect();
    const destRect = destination.getBoundingClientRect();

    // Style the clone
    clone.style.position = 'fixed';
    clone.style.zIndex = '9999';
    clone.style.left = `${sourceRect.left}px`;
    clone.style.top = `${sourceRect.top}px`;
    clone.style.width = `${sourceRect.width}px`;
    clone.style.height = `${sourceRect.height}px`;
    clone.style.opacity = '1';
    clone.style.pointerEvents = 'none';
    clone.style.transition = 'all 0.8s cubic-bezier(0.2, 1, 0.3, 1)';
    clone.style.borderRadius = '50%';
    clone.style.objectFit = 'cover';

    document.body.appendChild(clone);

    // Trigger animation in next frame
    requestAnimationFrame(() => {
      clone.style.left = `${destRect.left + destRect.width / 2 - 25}px`; // Center on cart icon (assuming 50px target size)
      clone.style.top = `${destRect.top + destRect.height / 2 - 25}px`;
      clone.style.width = '50px';
      clone.style.height = '50px';
      clone.style.opacity = '0';
    });

    // Cleanup and trigger destination animation
    setTimeout(() => {
      clone.remove();
      // Add scale animation to cart icon
      destination.classList.add('cart-icon-scale');
      setTimeout(() => destination.classList.remove('cart-icon-scale'), 300);
    }, 800);
  }
}

window.FlyToCart = FlyToCart;


